import React, { useState, useEffect } from 'react';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v2_categories, v2_channels } from '../../actions/v2/masterData';
import { v3_upload_plan_approval_document } from '../../actions/v3/planApproval';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { uploadSelectedFiles } from '../../utils/multipleFileUpload';

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const CreatePlanApprovalForm = ({ onSubmit, }) => {

    const [state, setState] = useState({
        title: { name: 'title', value: '', isRequired: true, error: '' },
        comment: { name: 'comment', value: '', isRequired: true, error: '' },
        documentFiles: { name: 'documentFiles', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);

        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        const payload = {
            commentTitle: state.title.value,
            comment: state.comment.value,
            documentFiles: getUploadedFiles(state.documentFiles.value),
        };

        onSubmit(payload);
    };

    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.documentFiles.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-12 mb-3">
                    <label>Topic {state.title.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type='text'
                        name="title"
                        className="form-control"
                        value={state.title.value}
                        onChange={handleChange}
                        placeholder="Enter Topic"
                    />
                </div>
                <div className="col-md-12 mb-3">
                    <label>Comment</label>
                    <textarea
                        name="comment"
                        className="form-control"
                        value={state.comment.value}
                        onChange={handleChange}
                        placeholder="Enter Comment"
                    />
                </div>
            </div>

            <div className="col-md-12 mb-3">
                <label>Upload Documents</label>

                {state.documentFiles.value.map((item, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                        {item.fileName ? (
                            <>
                                <div className="me-2 flex-grow-1">
                                    <span>{item.originalFileName}</span>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={() => removeFileField(index)}
                                >
                                    <FaTrash />
                                </button>
                            </>
                        ) : (
                            <>
                                <input
                                    type="file"
                                    multiple
                                    onChange={(e) => handleFileChange(index, e.target.files)}
                                    className="form-control me-2"
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={() => removeFileField(index)}
                                >
                                    <FaTrash />
                                </button>
                            </>
                        )}
                    </div>
                ))}
                {/* Add button always visible below the list */}
                <div>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={addFileField}
                    >
                        <FaPlus className="me-1" /> Add Document
                    </button>
                </div>

                {state.documentFiles.error && (
                    <div className="text-danger mt-1">{state.documentFiles.error}</div>
                )}
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.dashboard.url}>Cancel</a>
            </div>
        </form>
    );
};

export default CreatePlanApprovalForm;
